import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuth0Logout } from '../api';

const Auth0LogoutProvider = ({ children }) => {
    const { logout } = useAuth0();

    useEffect(() => {
    setAuth0Logout(logout);
    
    return () => {
        setAuth0Logout(null);
    };
    }, [logout]);

  return children;
};

export default Auth0LogoutProvider;
